import React, { Component } from "react";
// import { Link } from "react-router-dom";

import Seo from "../components/seo";
import ProjectItem from "../components/projectItem";
// import ShieldLogo from "../images/shield-vault.png";

import Web3 from "web3";
import LaunchPad from "../libs/launchPad";
import { Nav, Spinner } from "react-bootstrap";

import { getPresaleDetails } from "../libs/multicall";

class Projects extends Component {
  launchPad = new LaunchPad(
    this.props.config,
    new Web3(this.props.config.rpcUrl)
  );
  presaleCount = 0;
  constructor(props) {
    super(props);
    this.state = {
      allowed: [],
      comingSoon: [],
      closed: [],
      rejected: [],
      loading: false,
      showAll: true,
      showMy: false,
      running: [],
      myContributions: [],
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadPresales().then(() => {
      this.setState({
        loading: false,
      });
    });
  }
  showAllProjects = async () => {
    if (!this.state.showAll) {
      this.setState({ showAll: true, showMy: false });
      this.loadPresales().then(() =>
        this.setState({
          loading: false,
        })
      );
    }
  };
  showMyContibutions = async () => {
    if (!this.state.showMy) {
      this.setState({ showAll: false, showMy: true }, () => {
        if (this.props.appStatus.account !== undefined)
          this.loadMyContributions().then(() =>
            this.setState({
              loading: false,
            })
          );
      });
    }
  };
  loadPresales = async () => {
    this.setState({
      loading: true,
    });
    let comingSoon = [],
      closed = [],
      rejected = [],
      running = [];
    const presales = await getPresaleDetails(
      this.props.config.factory,
      this.launchPad.web3,
      (
        await this.launchPad.fetch(0, 100)
      )[0]
    );

    for (var presaleIndex = 0; presaleIndex < presales.length; presaleIndex++) {
      const { presaleIsApproved, presaleOpenAt, presaleCloseAt } =
        presales[presaleIndex];

      const openAt = Web3.utils.toBN(presaleOpenAt.hex).muln(1000).toNumber();
      const closeAt = Web3.utils.toBN(presaleCloseAt.hex).muln(1000).toNumber();

      if (presaleIsApproved && !presales[presaleIndex].isCanceled) {
        if (openAt > Date.now()) comingSoon.push(presales[presaleIndex]);
        else if (closeAt <= Date.now()) closed.push(presales[presaleIndex]);
        else running.push(presales[presaleIndex]);
      }
    }

    closed = closed.sort((a, b) => {
      return a.presaleCloseAt > b.presaleCloseAt ? 1 : -1;
    });

    this.setState({
      comingSoon,
      closed,
      rejected,
      running,
    });
  };
  showLoading = () => {
    return (
      <div className="text-center">
        <Spinner variant="warning" animation="border" />
      </div>
    );
  };
  loadMyContributions = async () => {
    this.setState({
      loading: true,
    });
    let comingSoon = [],
      closed = [],
      rejected = [],
      running = [];
    const presales = await getPresaleDetails(
      this.props.config.factory,
      this.launchPad.web3,
      (
        await this.launchPad.fetch(0, 100)
      )[0]
    );

    for (var presaleIndex = 0; presaleIndex < presales.length; presaleIndex++) {
      const userBNBAmount = await this.launchPad.getUserBNBAmount(
        presales[presaleIndex].presaleAddress,
        this.props.appStatus.account
      );

      if (Web3.utils.toBN(userBNBAmount).gtn(0)) {
        console.log("contributed");
        const { presaleIsApproved, presaleOpenAt, presaleCloseAt } =
          presales[presaleIndex];

        const openAt = Web3.utils.toBN(presaleOpenAt.hex).muln(1000).toNumber();
        const closeAt = Web3.utils
          .toBN(presaleCloseAt.hex)
          .muln(1000)
          .toNumber();

        if (presaleIsApproved && !presales[presaleIndex].isCanceled) {
          if (openAt > Date.now()) comingSoon.push(presales[presaleIndex]);
          else if (closeAt <= Date.now()) closed.push(presales[presaleIndex]);
          else running.push(presales[presaleIndex]);
        }
      }
    }

    closed = closed.sort((a, b) => {
      return a.presaleCloseAt > b.presaleCloseAt ? 1 : -1;
    });

    this.setState({
      comingSoon,
      closed,
      rejected,
      running,
    });
  };
  render() {
    return (
      <>
        <Seo pageTitle="Projects"></Seo>
        <div className="pp-homepage">
          <div className="container">
            <div className="row d-flex justify-content-center mt-5">
              <div className="ms-auto me-auto w-auto">
                <Nav className="projects-nav">
                  <Nav.Link
                    onClick={(e) => this.showAllProjects()}
                    className={this.state.showAll ? "active" : ""}
                  >
                    All Projects
                  </Nav.Link>
                  <Nav.Link className="nav-link-separator"></Nav.Link>
                  <Nav.Link
                    onClick={(e) => this.showMyContibutions()}
                    className={this.state.showMy ? "active" : ""}
                  >
                    My Contributions
                  </Nav.Link>
                </Nav>
              </div>
            </div>
            {this.state.showAll ? (
              <div className="row">
                <div
                  className="col-lg-12"
                  style={{ backgroundColor: "#1a1a1a !important" }}
                >
                  {/* <div className="pp-projects-page mt-5 pt-3 d-grid justify-content-center"> */}
                  <div className="pp-projects-page pt-3 justify-content-center">
                    <div className="pp-investment pp-open">
                      <div className="text-center">
                        <div className="row d-flex">
                          <div className="col-lg-12 text-center">
                            <div className="section-text">
                              <h2 className="section-title">
                                Launches Open Now
                              </h2>
                              <p className="section-description"></p>
                            </div>
                          </div>
                        </div>
                        <div className="investment-section-items">
                          <div className="row d-flex justify-content-center">
                            {this.state.loading ? (
                              this.showLoading()
                            ) : this.state.running.length === 0 ? (
                              <div>
                                <span>No launches currently open</span>
                              </div>
                            ) : (
                              this.state.running.map(
                                (presaleDetails, index) => {
                                  return (
                                    <ProjectItem
                                      launchPad={this.launchPad}
                                      details={presaleDetails}
                                      key={index}
                                      status="open"
                                      statusText="Open"
                                    />
                                  );
                                }
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="pp-investment pt-0"
                      style={{ backgroundImage: "none" }}
                    >
                      <div className="text-center">
                        <div className="row d-flex justify-content-center">
                          <div className="col-lg-12 text-center">
                            <div className="section-text">
                              <h2 className="section-title">
                                Launches Coming soon
                              </h2>
                              <p className="section-description"></p>
                            </div>
                          </div>
                        </div>
                        <div className="investment-section-items">
                          <div className="row d-flex justify-content-center">
                            {this.state.loading ? (
                              this.showLoading()
                            ) : this.state.comingSoon.length === 0 ? (
                              <div>
                                <span>No launches comming soon</span>
                              </div>
                            ) : (
                              this.state.comingSoon.map(
                                (presaleDetails, index) => {
                                  return (
                                    <ProjectItem
                                      launchPad={this.launchPad}
                                      details={presaleDetails}
                                      key={index}
                                      status="opening"
                                      statusText="Opens in"
                                    />
                                  );
                                }
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="pp-investment pp-close">
                      <div className="container text-center">
                        <div className="row d-flex justify-content-center">
                          <div className="row d-flex justify-content-center">
                            <div className="col-lg-12 text-center">
                              <div className="section-text">
                                <h2 className="section-title">
                                  Launches Closed
                                </h2>
                                <p className="section-description"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="investment-section-items">
                          <div className="row d-flex justify-content-center">
                            {this.state.loading ? (
                              this.showLoading()
                            ) : this.state.closed.length === 0 ? (
                              <div>
                                <span>No launches currently closed</span>
                              </div>
                            ) : (
                              this.state.closed.map((presaleDetails, index) => {
                                return (
                                  <ProjectItem
                                    launchPad={this.launchPad}
                                    details={presaleDetails}
                                    key={index}
                                    status="closed"
                                    statusText="Closed"
                                  />
                                );
                              })
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            {this.state.showMy ? (
              <div className="row pt-3">
                <div className="pp-investment pp-open">
                  <div className="text-center">
                    <div className="row d-flex">
                      <div className="col-lg-12 text-center">
                        <div className="section-text">
                          <h2 className="section-title">My Contributions</h2>
                          <p className="section-description"></p>
                        </div>
                      </div>
                    </div>
                    <div className="investment-section-items">
                      <div className="row d-flex justify-content-center">
                        {this.state.loading ? (
                          this.showLoading()
                        ) : this.state.running.length === 0 &&
                          this.state.closed.length === 0 ? (
                          <div>
                            <span>You have made no contributions.</span>
                          </div>
                        ) : (
                          <>
                            {this.state.running.map((presaleDetails, index) => {
                              return (
                                <ProjectItem
                                  launchPad={this.launchPad}
                                  details={presaleDetails}
                                  key={index}
                                  status="open"
                                  statusText="Open"
                                />
                              );
                            })}
                            {this.state.closed.map((presaleDetails, index) => {
                              return (
                                <ProjectItem
                                  launchPad={this.launchPad}
                                  details={presaleDetails}
                                  key={index}
                                  status="closed"
                                  statusText="Closed"
                                />
                              );
                            })}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default Projects;
